// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setMinutes = convertToFP(fn, 2);
export default setMinutes;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setMinutes/index.js
// module id = 977
// module chunks = 0